import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IFixingSourceLookupService } from "../IFixingSourceLookupService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FixingSourceLookupService
  extends BaseLookupService<string, CubiqTS.NdfSourceImpl>
  implements IFixingSourceLookupService
{
  private mySourcesByPairMap: Map<string, Map<string, any>> = new Map();
  private fixingSourcePair: Map<string, string> = new Map();
  private myAllAdaptedSources: Map<string, any> = new Map();

  constructor() {
    super(CubiqTS.NdfSourceImpl);
    this.myAllAdaptedSources.set("-1", {
      isDefault: false,
      isCustom: true,
      label: "- CUSTOM -",
      pair: null,
      id: -1,
    });
  }

  getFixingSource(id: string): CubiqTS.NdfSourceImpl {
    if (id == undefined || id == null) return null;
    var fixingSource = this.getItem(id);
    return fixingSource;
  }

  getItemKey(item: any): string {
    if (item.id != undefined && item.id != null) return item.id.toString();
    return null;
  }

  getAllAdaptedFixingSources(): Array<any> {
    return [...this.myAllAdaptedSources.values()];
  }
  getFixingSourcesForPair(pair: string): Array<any> {
    let map = this.mySourcesByPairMap.get(pair);
    if (map) {
      return [...map.values()];
    }
    return [{ isDefault: false, isCustom: true, label: "- CUSTOM -", pair: pair, id: -1 }];
  }

  getFixingSourceInPair(fixingSourceCd: string, pair: string): any {
    let map = this.mySourcesByPairMap.get(pair);
    if (map) {
      return map.get(fixingSourceCd);
    }
    if (fixingSourceCd == "- CUSTOM -") {
      return {
        isDefault: false,
        isCustom: true,
        label: "- CUSTOM -",
        pair: pair,
        id: -1,
      };
    }
    return null;
  }

  private adaptSource(source: CubiqTS.NdfSourceImpl): any {
    return {
      isDefault: source.isDefault,
      isCustom: false,
      label: source.fixingCode,
      pair: source.ccyPair,
      id: source.id.toNumber(),
    };
  }

  mapItem(item: CubiqTS.NdfSourceImpl): void {
    let itemId: string = this.getItemKey(item);
    if (this.fixingSourcePair.has(itemId)) {
      // delete it from the old one
      let oldPair: string = this.fixingSourcePair.get(itemId);
      let oldSourcePair: Map<string, any> = this.mySourcesByPairMap.get(oldPair);
      if (oldSourcePair && oldSourcePair.has(item.fixingCode)) {
        oldSourcePair.delete(item.fixingCode);
      }
    }
    if (!this.mySourcesByPairMap.has(item.ccyPair)) {
      let newMap = new Map();
      this.mySourcesByPairMap.set(item.ccyPair, newMap);
      let custom = {
        isDefault: false,
        isCustom: true,
        label: "- CUSTOM -",
        pair: item.ccyPair,
        id: -1,
      };
      newMap.set("- CUSTOM -", custom);
    }
    this.fixingSourcePair.set(itemId, item.ccyPair);
    let sourcePair: Map<string, any> = this.mySourcesByPairMap.get(item.ccyPair);
    if (!sourcePair.has(item.fixingCode)) {
      sourcePair.set(item.fixingCode, this.adaptSource(item));
    }
    if (!this.myAllAdaptedSources.has(itemId)) {
      this.myAllAdaptedSources.set(itemId, this.adaptSource(item));
    }
    super.mapItem(item);
  }

  deleteItem(item: CubiqTS.NdfSourceImpl, id: string = null): void {
    let itemId: string = this.getItemKey(item);
    super.deleteItem(item, id);
    if (this.fixingSourcePair.has(itemId)) {
      // delete it from the old one
      let oldPair: string = this.fixingSourcePair.get(itemId);
      let oldSourcePair: Map<string, any> = this.mySourcesByPairMap.get(oldPair);
      if (oldSourcePair && oldSourcePair.has(item.fixingCode)) {
        oldSourcePair.delete(item.fixingCode);
      }
    }
    if (this.myAllAdaptedSources && this.myAllAdaptedSources.has(itemId)) {
      this.myAllAdaptedSources.delete(itemId);
    }
  }
}
